import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3t5pew5dxb: FaireBrandEntity = {
  token: "b_3t5pew5dxb",
  type: "brand",
  name: "Minimalistajoyeria",
  avatarUrl:
    "https://cdn.faire.com/fastly/e12440d042f1e342cfe885327c7d7afd44e01cee2fe5e463ade2c85b9fe4e1c7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8d9a950d84ccc93de90e0b1dc00ade21281195b633517ef68dc40445784297c8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e12440d042f1e342cfe885327c7d7afd44e01cee2fe5e463ade2c85b9fe4e1c7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8d9a950d84ccc93de90e0b1dc00ade21281195b633517ef68dc40445784297c8.jpeg",
  location: "ESP",
  minimumOrderDollars: 160,
  rating: 5,
  reviewCount: 3,
  isInsider: false,
  description:
    "Welcome to Minimalistajoyeria!\n\nWe are a family business with a long history in the high-end traditional jewelry sector (working for years with Platinum and 18K Gold). Today, we bring all that experience and excellence to 316L and 304 Stainless Steel with PVD technology.\n\nWhy trust Minimalistajoyeria?\n\nFine Jewelry Quality: Waterproof pieces, hypoallergenic, and that do not lose their shine.\n\nReal Photography: All images are ours, taken in our studio in Spain. What you see is what you receive.\n\nStock in Spain: Fast shipments with no customs.\n\nDirect Price: Luxury aesthetics at factory prices.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:37.647Z",
    importedBy: "entity-db-cli",
  },
};
